<!-- src/app/components/create-licence-package/create-licence-package.component.html -->

<h1 mat-dialog-title>{{ 'admin_create_licence_package_title' | i18next }}</h1>
<div mat-dialog-content>
    <form [formGroup]="licenceForm">
        <!-- Package Type Selection -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'admin_create_licence_package_type' | i18next }}</mat-label>
            <mat-select formControlName="type">
                <mat-option *ngFor="let type of packageTypes" [value]="type">{{ type }}</mat-option>
            </mat-select>
            <mat-error *ngIf="f['type'].hasError('required')">
                {{ 'admin_create_licence_package_type_required' | i18next }}
            </mat-error>
        </mat-form-field>

        <!-- Package Size Input -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'admin_create_licence_package_size' | i18next }}</mat-label>
            <input matInput type="number" formControlName="packageSize" />
            <mat-error *ngIf="f['packageSize'].hasError('required')">
                {{ 'admin_create_licence_package_size_required' | i18next }}
            </mat-error>
            <mat-error *ngIf="f['packageSize'].hasError('min')">
                {{ 'admin_create_licence_package_size_min' | i18next }}
            </mat-error>
        </mat-form-field>

        <!-- Start Date Picker -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'admin_create_licence_package_start_date' | i18next }}</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="startDate" />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
            <mat-error *ngIf="f['startDate'].hasError('required')">
                {{ 'admin_create_licence_package_start_date_required' | i18next }}
            </mat-error>
        </mat-form-field>

        <!-- End Date Picker -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'admin_create_licence_package_end_date' | i18next }}</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="endDate" />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
            <mat-error *ngIf="f['endDate'].hasError('required')">
                {{ 'admin_create_licence_package_end_date_required' | i18next }}
            </mat-error>
            <mat-error *ngIf="licenceForm.errors?.['endDateBeforeStartDate']">
                {{ 'admin_create_licence_package_end_date_invalid' | i18next }}
            </mat-error>
        </mat-form-field>

        <!-- Description Textarea -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'admin_create_licence_package_description' | i18next }}</mat-label>
            <textarea matInput formControlName="description"></textarea>
        </mat-form-field>

        <!-- Price Input -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'admin_create_licence_package_price' | i18next }}</mat-label>
            <input matInput type="number" formControlName="price" />
            <mat-error *ngIf="f['price'].hasError('min')">
                {{ 'admin_create_licence_package_price_min' | i18next }}
            </mat-error>
        </mat-form-field>

        <!-- Discount Amount Input -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'admin_create_licence_package_discount_amount' | i18next }}</mat-label>
            <input matInput type="number" formControlName="discountAmount" />
            <mat-error *ngIf="f['discountAmount'].hasError('min')">
                {{ 'admin_create_licence_package_discount_amount_min' | i18next }}
            </mat-error>
        </mat-form-field>

        <!-- Discount Percent Input -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>{{ 'admin_create_licence_package_discount_percent' | i18next }}</mat-label>
            <input matInput type="number" formControlName="discountPercent" />
            <mat-error *ngIf="f['discountPercent'].hasError('min')">
                {{ 'admin_create_licence_package_discount_percent_min' | i18next }}
            </mat-error>
            <mat-error *ngIf="f['discountPercent'].hasError('max')">
                {{ 'admin_create_licence_package_discount_percent_max' | i18next }}
            </mat-error>
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
        {{ 'admin_create_licence_package_cancel' | i18next }}
    </button>
    <button mat-button color="primary" (click)="onSave()" [disabled]="licenceForm.invalid">
        {{ 'admin_create_licence_package_confirm' | i18next }}
    </button>
</div>
